import ModalsPopup from "@components/Modals/ModalsPopup";
import { StyledButton } from "@components/Styled/Button";
import { ComponentProps } from "@ts/components";
import React, { useState } from "react";
import QuestionsForm from "./QuestionsForm";
import { Button as ButtonUi } from "@bared/ui";

import { clsx } from "clsx";

type AddNewQuestionProps = ComponentProps & {
  sku: string;
  productUrl: string;
};

const Button = (props: any) => (
  <StyledButton
    {...props}
    className={clsx(
      props.className,
      "w-full border border-primary hover:border-secondary hover:bg-secondary hover:text-white md:max-w-[330px]",
    )}
  />
);

const Form = (props: any) => (
  <QuestionsForm
    {...props}
    className={clsx(
      props.className,
      "mx-auto max-w-[720px] py-mega md:px-mega",
    )}
  />
);

const AddNewQuestion = ({
  className,
  sku,
  productUrl,
}: AddNewQuestionProps) => {
  const [active, setActive] = useState(false);

  return (
    <>
      {process.env["GATSBY_FEATURE_REVIEWS_ENHANCEMENT"] ? (
        <ButtonUi
          className={className}
          size="large"
          variant="secondary"
          onClick={() => setActive(true)}
        >
          Ask a Question
        </ButtonUi>
      ) : (
        <Button
          height="56"
          textSize="16"
          colour="transparent"
          onClick={() => setActive(true)}
        >
          Ask a question
        </Button>
      )}
      <ModalsPopup active={active} setActive={setActive} layout="review">
        <Form sku={sku} productUrl={productUrl} />
      </ModalsPopup>
    </>
  );
};

export default AddNewQuestion;
